import { keyframes } from '@emotion/css';

import {
  ALTO_GATILLO,
  CARRIL_ABAJO,
  CARRIL_ARRIBA,
} from '#components/mobile/budget/GatilloDinero';
import { useReducedMotion } from '#hooks/useReducedMotion';

import { LATON } from './OjoBuey';

/**
 * La pestaña Dinero deslizándose arriba y abajo con un dedo encima, pintada
 * por la ayuda sobre la de verdad (Vadik, 26-oct-2026: «muévelo para que se
 * vea que se mueve»). Solo enseña el gesto: no filtra nada.
 */
export function GatilloFantasma() {
  const quieta = useReducedMotion();
  const alto = window.innerHeight;
  const arriba = alto * CARRIL_ARRIBA - ALTO_GATILLO / 2;
  const recorrido = alto * (CARRIL_ABAJO - CARRIL_ARRIBA);
  const desliza = keyframes({
    '0%, 12%': { transform: 'translateY(0)' },
    '50%, 62%': { transform: `translateY(${recorrido}px)` },
    '100%': { transform: 'translateY(0)' },
  });
  return (
    <div
      aria-hidden
      data-testid="ayuda-gatillo-fantasma"
      style={{
        position: 'absolute',
        right: 0,
        top: arriba,
        width: 64,
        height: ALTO_GATILLO,
        pointerEvents: 'none',
        animation: quieta
          ? 'none'
          : `${desliza} 3.6s cubic-bezier(.45,.05,.35,1) infinite`,
      }}
    >
      <span
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          width: 24,
          height: '100%',
          borderRadius: '12px 0 0 12px',
          background: `linear-gradient(90deg, #9b6b22, #d4a548 35%, ${LATON.claro} 62%, #d4a548)`,
          boxShadow:
            '-2px 3px 8px rgba(60, 40, 10, 0.3), inset 1px 0 0 rgba(255, 240, 200, 0.6)',
        }}
      />
      <span
        style={{
          position: 'absolute',
          right: 2,
          top: ALTO_GATILLO / 2 - 20,
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          border: '2px solid rgba(255, 255, 255, 0.95)',
          boxShadow:
            '0 0 0 7px rgba(201, 151, 59, 0.3), 0 4px 14px rgba(14, 20, 36, 0.35)',
        }}
      />
    </div>
  );
}
